export interface PayloadJwt {
  apellido1: string;
  apellido2: string;
  buzon: string;
  caducidad: number;
  caducidadPwd: number;
  exp: number;
  fechaUltimoAcceso: number;
  iat: number;
  nombre: string;
  numeroLineas: number;
  perfiles: string[];
  descripcionesPerfiles: string[];
  sub: string;
  regionDelConcesionario: string;
}

export class JwtDTO {
  token: string;
  constructor(token: string) {
    this.token = token;
  }
}
